<template>
  <div class="modul"
       style="height: 600px;overflow: scroll;text-align: left;">
    <el-row>
      <el-col :span="4">
        <el-image style="width: 100%;height:100%;border-radius: 5px;overflow: hidden;"
                  :src="qiaoliangxiangqingData.scenePictureUrl[0]"
                  :preview-src-list="qiaoliangxiangqingData.scenePictureUrl"></el-image>
      </el-col>
      <el-col :span="18"
              style="margin-left: 40px;">
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti"
              style="margin-top: 0px;">基本信息</h4>
          <div class="xinxi">
            <div>桥梁名称：<span style="color: #6ECAD2;">{{ qiaoliangxiangqingData.bridgeName }}</span></div>
            <div>地址：<span style="color: #6ECAD2;">{{ qiaoliangxiangqingData.address }}</span></div>
            <div>归属区域：{{ qiaoliangxiangqingData.ascriptionName }}</div>
            <div>经度：{{ qiaoliangxiangqingData.longitude }}</div>
            <div>纬度：{{ qiaoliangxiangqingData.latitude }}</div>
            <div>巡检单位：{{ qiaoliangxiangqingData.curingUtil }}</div>
            <div>巡查周期：{{ qiaoliangxiangqingData.inspectionCycle }}</div>
            <div>开始时间：{{ qiaoliangxiangqingData.inspectionCycleStart }}</div>
          </div>
          <div>
            <span style="display: inline-block;margin-right: 26px;">介绍：</span>
            <div style="display: inline-block;color: #666;">{{ qiaoliangxiangqingData.introduce }}</div>
          </div>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">设备配置</h4>
          <el-table :data="tableData"
                    height="260"
                    style="width: 100%;border-radius: 5px;"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ 'text-align': 'center' }"
                    :cell-style="{ 'text-align': 'center' }">
            <el-table-column type="index"
                             label="编号"
                             width="50">
            </el-table-column>
            <el-table-column prop="equipmentAnotherName"
                             label="设备别名"
                             width="180">
            </el-table-column>
            <el-table-column prop="equipmentCode"
                             label="设备编码">
            </el-table-column>
            <el-table-column prop="sim"
                             label="SIM卡号">
            </el-table-column>
            <el-table-column prop="dtuId"
                             label="dtuId">
            </el-table-column>
            <el-table-column prop="channelCount"
                             label="通道总数">
            </el-table-column>
            <!-- <el-table-column prop="modelId"
                             label="设备模块号">
            </el-table-column> -->
            <el-table-column prop="address"
                             label="预警值">
              <template #default="scope">
                <div class="warning-value">
                  <div>{{ scope.row.beginWarningValue }}</div>
                  <div class="input-line">
                  </div>
                  <div>{{ scope.row.endWarningValue }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="equipmentTypeName"
                             label="设备类型">
            </el-table-column>
            <el-table-column prop="communicationChannel"
                             label="通信通道">
            </el-table-column>
            <el-table-column prop="status"
                             label="状态">
              <template #default="scope">
                <div :class="scope.row.status == 0 ? '' : scope.row.status == 1 ? 'isStatus' : 'isRed'"
                     class="default-status">
                  <div :class="scope.row.status == 0 ? '' : scope.row.status == 1 ? 'isCircle' : 'isRedle'"
                       class="circle-div"></div>
                  <div>{{ scope.row.status == 0 ? '离线' : scope.row.status == 1 ? '在线' : '未检测到状态' }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">照片</h4>
          <div v-if="qiaoliangxiangqingData.scenePictureUrl && qiaoliangxiangqingData.scenePictureUrl.length > 0"
               style="display: flex;">
            <div v-for="item in qiaoliangxiangqingData.scenePictureUrl"
                 :key="item"
                 style="width: 140px;height: 140px;margin-bottom: 10px;margin-right: 15px;">
              <el-image style="width: 100%;height:100%;border-radius: 5px;overflow: hidden;"
                        :src="item"
                        :preview-src-list="[item]"></el-image>
            </div>
          </div>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">档案</h4>
          <div>
            <el-row>
              <el-col :span="6">
                <div class="dangan">设计档案</div>
                <div style="margin-top: 10px;"
                     v-if="qiaoliangxiangqingData.designDocumentUrl && qiaoliangxiangqingData.designDocumentUrl.length > 0">
                  <div style="margin-top: 5px;"
                       v-for="item, index in qiaoliangxiangqingData.designDocumentUrl" :key="index">
                    <img src="../../../../assets/image/old/文件夹@2x.png"
                         alt=""
                         style="width: 20px;height: 20px;margin-right: 5px;">
                    <a href="javascript:void(0);"
                       @click="detailsRow(item)"
                       style="color: #11528b;">{{ item }}</a>
                  </div>
                </div>
              </el-col>
              <el-col :span="6"
                      style="margin-left: 20px;">
                <div>检测档案</div>
                <div style="margin-top: 10px;"
                     v-if="qiaoliangxiangqingData.checkDocumentUrl && qiaoliangxiangqingData.checkDocumentUrl.length > 0">
                  <div style="margin-top: 5px;"
                       v-for="item, index in qiaoliangxiangqingData.checkDocumentUrl" :key="index">
                    <img src="../../../../assets/image/old/文件夹@2x.png"
                         alt=""
                         style="width: 20px;height: 20px;margin-right: 5px;">
                    <a href="javascript:void(0);"
                       @click="detailsRow(item)"
                       style="color: #11528b;">{{ item }}</a>
                  </div>
                </div>
              </el-col>
              <el-col :span="6"
                      style="margin-left: 20px;">
                <div>巡检档案</div>
                <div style="margin-top: 10px;"
                     v-if="qiaoliangxiangqingData.inspectionDocumentUrl && qiaoliangxiangqingData.inspectionDocumentUrl.length > 0">
                  <div style="margin-top: 5px;"
                       v-for="item, index in qiaoliangxiangqingData.inspectionDocumentUrl"
                       :key="index">
                    <img src="../../../../assets/image/old/文件夹@2x.png"
                         alt=""
                         style="width: 20px;height: 20px;margin-right: 5px;">
                    <a href="javascript:void(0);"
                       @click="detailsRow(item)"
                       style="color: #11528b;">{{ item }}</a>
                  </div>
                </div>
              </el-col>
            </el-row>

          </div>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">健康状态</h4>
          <div style="margin-bottom: 10px;">桥梁状态：<span style="color: #6ECAD2;">{{ qiaoliangxiangqingData.status }}</span>
          </div>
          <div>
            <span style="display: inline-block;">评判标准：</span>
            <div style="display: inline-block;color: #666;">{{ qiaoliangxiangqingData.criteria }}</div>
          </div>
        </div>
        <div>
          <span class="shubian"></span>
          <h4 class="biaoti">一桥一档</h4>
          <div>
            <el-image style="width: 170px;height:170px;border-radius: 5px;overflow: hidden;"
                      :src="qiaoliangxiangqingData.bridgePicture"
                      :preview-src-list="[qiaoliangxiangqingData.bridgePicture]"></el-image>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'qiaoliangxiangqing',
  props: {
    qiaoliangxiangqingData: {
      type: Object,
      default: {},
    },
  },
  watch: {
    qiaoliangxiangqingData: {
      deep: true,
      handler(n, l) {
        console.log(n, l)
        if (n.biEquipmentList && n.biEquipmentList.length > 0) {
          this.tableData = n.biEquipmentList
        } else {
          this.tableData = []
        }
        if (this.qiaoliangxiangqingData.designDocumentUrl && this.qiaoliangxiangqingData.designDocumentUrl.length > 0) {
          this.qiaoliangxiangqingData.designDocumentUrl = this.qiaoliangxiangqingData.designDocumentUrl.split(',')
        } else {
          this.qiaoliangxiangqingData.designDocumentUrl = ''
        }
        if (this.qiaoliangxiangqingData.checkDocumentUrl && this.qiaoliangxiangqingData.checkDocumentUrl.length > 0) {
          this.qiaoliangxiangqingData.checkDocumentUrl = this.qiaoliangxiangqingData.checkDocumentUrl.split(',')
        } else {
          this.qiaoliangxiangqingData.checkDocumentUrl = ''
        }
        if (this.qiaoliangxiangqingData.inspectionDocumentUrl && this.qiaoliangxiangqingData.inspectionDocumentUrl.length > 0) {
          this.qiaoliangxiangqingData.inspectionDocumentUrl = this.qiaoliangxiangqingData.inspectionDocumentUrl.split(',')
        } else {
          this.qiaoliangxiangqingData.inspectionDocumentUrl = ''
        }
      },
    }
  },
  components: {
  },
  data() {
    return {
      tableData: [],
    }
  },
  mounted() {
    if (this.qiaoliangxiangqingData.biEquipmentList && this.qiaoliangxiangqingData.biEquipmentList.length > 0) {
      this.tableData = this.qiaoliangxiangqingData.biEquipmentList
    } else {
      this.tableData = []
    }
    if (this.qiaoliangxiangqingData.designDocumentUrl && this.qiaoliangxiangqingData.designDocumentUrl.length > 0) {
      this.qiaoliangxiangqingData.designDocumentUrl = this.qiaoliangxiangqingData.designDocumentUrl.split(',')
    } else {
      this.qiaoliangxiangqingData.designDocumentUrl = ''
    }
    if (this.qiaoliangxiangqingData.checkDocumentUrl && this.qiaoliangxiangqingData.checkDocumentUrl.length > 0) {
      this.qiaoliangxiangqingData.checkDocumentUrl = this.qiaoliangxiangqingData.checkDocumentUrl.split(',')
    } else {
      this.qiaoliangxiangqingData.checkDocumentUrl = ''
    }
    if (this.qiaoliangxiangqingData.inspectionDocumentUrl && this.qiaoliangxiangqingData.inspectionDocumentUrl.length > 0) {
      this.qiaoliangxiangqingData.inspectionDocumentUrl = this.qiaoliangxiangqingData.inspectionDocumentUrl.split(',')
    } else {
      this.qiaoliangxiangqingData.inspectionDocumentUrl = ''
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'success-row'
      } else {
        return 'warning-row'
      }
    },
    //下载
    detailsRow(data) {
      console.log('下载数据', data)
      const a = document.createElement('a')
      a.href = data.fileUrl
      // a.download = '文件名1'; // 下载后文件名
      a.setAttribute("download", data.fileName)
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
  },
}
</script>

<style lang="scss" scoped>
.shubian {
  width: 3px;
  height: 16px;
  background: linear-gradient(0deg, #20b9b9 0%, #83f4fe 100%);
  border-radius: 2px;
  display: inline-block;
}

.input-line {
  margin: 0 10px;
  width: 30px;
  border-bottom: 1px solid #999999;
}

.xinxi {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}

.xinxi>div {
  margin-right: 40px;
  margin-bottom: 10px;
}

.biaoti {
  display: inline-block;
  margin-left: 10px;
  margin-top: 25px;
  margin-bottom: 5px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #4d4d4d;
  line-height: 50px;
}

.isStatus {
  color: #30bb4c;
}

.isCircle {
  background-color: #30bb4c;
}

.isRed {
  color: #FF5722;
}

.isRedle {
  background-color: #FF5722;
}

::v-deep .el-table thead {
  color: #fff;
}

::v-deep .el-table th.el-table__cell {
  background-color: #6ecad2;
  border-left: 1px solid #52a8b0;
}

::v-deep .el-table .warning-row {
  background: #dff0f2;
}

::v-deep .el-table .success-row {
  background: #eef6f7;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>
